const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLookupSingle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#D9E5F8",
    style: {
      fill: "#D9E5F8",
      fill: "color(display-p3 0.8494 0.8973 0.9718)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 7.33398C12.2535 7.33398 10.8335 8.75398 10.8335 10.5007C10.8335 12.214 12.1735 13.6007 13.9202 13.6607C13.9735 13.654 14.0268 13.654 14.0668 13.6607C14.0802 13.6607 14.0868 13.6607 14.1002 13.6607C14.1068 13.6607 14.1068 13.6607 14.1135 13.6607C15.8202 13.6007 17.1602 12.214 17.1668 10.5007C17.1668 8.75398 15.7468 7.33398 14.0002 7.33398Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3866 15.4339C15.5266 14.1939 12.4933 14.1939 10.62 15.4339C9.77331 16.0006 9.30664 16.7672 9.30664 17.5872C9.30664 18.4072 9.77331 19.1672 10.6133 19.7272C11.5466 20.3539 12.7733 20.6672 14 20.6672C15.2266 20.6672 16.4533 20.3539 17.3866 19.7272C18.2266 19.1606 18.6933 18.4006 18.6933 17.5739C18.6866 16.7539 18.2266 15.9939 17.3866 15.4339Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookupSingle);
export default __webpack_public_path__ + "static/media/lookup-single.b34070760b13581acaaa70c4926abfd7.svg";
export { ForwardRef as ReactComponent };